import { useState } from "react";
import { AppPTORequests } from "../app-time-off/AppPTORequests";
import { DCBaseProps } from "./DCBase";
import { AppPTOPoliciesNavigationActions } from "../app-time-off/AppPTOPolicies";
import { PaidTimeOffPolicy } from "winslow-core";

type DCPTOHistoryProps = DCBaseProps & {
    data: {
        employeeRecordIds: string[] | undefined;
    }
}

export const DCPTOHistory = ({data, isOutdated, message}: DCPTOHistoryProps) => {

    console.log("[DCPTOHistory] isOutdated: ", isOutdated);
    console.log("[DCPTOHistory] data: ", data);

    if (isOutdated) {
        return (
            <div className="dc-component-outdated">
                PTO Request no longer available.
            </div>
        );
    }

    return (
        <div className="dc-component-card">   
            <AppPTORequests 
                dynamicContext={{ employeeRecordIds: data.employeeRecordIds }}
                disabled={isOutdated}
            />
        </div>
    )
}